import { LockReset, Telegram, WhatsApp } from '@mui/icons-material';
import { Card, Grid2, Typography } from '@mui/material';
import ButtonComponent from 'components/ButtonComponent';
import IconImageComponent from 'components/IconImageComponent';
import moni_icon from '../../../../assets/images/icons/devices/moni_icon.png';
import sigma_icon from '../../../../assets/images/icons/devices/sigma_icon.png';
import OutputManagementModal from './OutputManagement';
import { useState } from 'react';

interface OutputsListProps {
  alarmCentral: any;
}
export type IntegrationType =
  | 'MONI'
  | 'SURGARD'
  | 'SIGMA'
  | 'WHATSAPP'
  | 'TELEGRAM'
  | 'DEVICES';

const OutputsList = ({ alarmCentral }: OutputsListProps) => {
  const [isOpenOutputManagementModal, setIsOpenOutputManagementModal] =
    useState(false);
  const [integrationTypeSelected, setIntegrationTypeSelected] =
    useState<IntegrationType>();

  const openOutputEditionModal = (integrationType: IntegrationType) => {
    setIntegrationTypeSelected(integrationType);
    setIsOpenOutputManagementModal(true);
  };

  return (
    <Card
      sx={{ padding: 2, flex: 1 }}
      style={{ border: '1px solid rgb(47, 57, 87)', height: '100%' }}
    >
      <Grid2
        container
        sx={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Grid2>
          <Typography sx={{ fontWeight: 'bold' }}>
            CONFIGURAÇÃO DAS SAÍDAS
          </Typography>
        </Grid2>
        <Grid2
          size={12}
          container
          columnSpacing={2}
          rowSpacing={2}
          sx={{ mt: 1 }}
        >
          <Grid2 size={{ xl: 6, xs: 12 }}>
            <ButtonComponent
              fullWidth
              size="small"
              variant="outlined"
              onClick={() => openOutputEditionModal('MONI')}
              startIcon={<IconImageComponent src={moni_icon} />}
            >
              MONI
            </ButtonComponent>
          </Grid2>
          <Grid2 size={{ xl: 6, xs: 12 }}>
            <ButtonComponent
              fullWidth
              size="medium"
              variant="outlined"
              onClick={() => openOutputEditionModal('SURGARD')}
              startIcon={<LockReset fontSize={'large'} color="success" />}
            >
              SURGARD
            </ButtonComponent>
          </Grid2>
          <Grid2 size={{ xl: 6, xs: 12 }}>
            <ButtonComponent
              fullWidth
              size="small"
              onClick={() => openOutputEditionModal('SIGMA')}
              variant="outlined"
              startIcon={<IconImageComponent src={sigma_icon} />}
            >
              SIGMA
            </ButtonComponent>
          </Grid2>
          <Grid2 size={{ xl: 6, xs: 12 }}>
            <ButtonComponent
              fullWidth
              size="medium"
              onClick={() => openOutputEditionModal('WHATSAPP')}
              variant="outlined"
              startIcon={<WhatsApp color="success" />}
            >
              WHATSAPP
            </ButtonComponent>
          </Grid2>
          <Grid2 size={{ xl: 6, xs: 12 }}>
            <ButtonComponent
              fullWidth
              size="medium"
              variant="outlined"
              onClick={() => openOutputEditionModal('TELEGRAM')}
              startIcon={<Telegram />}
            >
              TELEGRAM
            </ButtonComponent>
          </Grid2>
          <Grid2 size={{ xl: 6, xs: 12 }}>
            <ButtonComponent
              fullWidth
              size="medium"
              variant="outlined"
              onClick={() => openOutputEditionModal('DEVICES')}
              startIcon={<LockReset fontSize={'large'} color="success" />}
            >
              DISPOSITIVOS
            </ButtonComponent>
          </Grid2>
        </Grid2>
      </Grid2>
      <OutputManagementModal
        isOpen={isOpenOutputManagementModal}
        alarmCentral={alarmCentral}
        integrationTypeSelected={integrationTypeSelected}
        onClose={() => setIsOpenOutputManagementModal(false)}
      />
    </Card>
  );
};

export default OutputsList;
